import './sidebar.css'
import { RssFeedOutlined, SettingsOutlined, BookmarkBorderOutlined, AccountCircleOutlined, MessageOutlined, ArchiveOutlined, DeleteOutlined } from "@material-ui/icons"
import { NavLink, useHistory } from 'react-router-dom'
import { useContext } from 'react'
import { AuthContext } from '../../context/AuthContext'

const Sidebar = () => {
    const PF = process.env.REACT_APP_PUBLIC_FOLDER
    const {user} = useContext(AuthContext)

    const history = useHistory()

    const handleRogerClick = () => {
        history.push('/roger')
        window.location.reload()
    }

    return (
        <div className="sidebar">
            <div className="sidebarWrapper">
                <div className="sidebarList">
                    <NavLink exact to={`/`} className="sidebarListItem" activeClassName="active-link">
                        <RssFeedOutlined className="sidebarIcon" />
                        <span className="sidebarListItemText">Feed</span>
                    </NavLink>
                    <NavLink exact to={`/profile/${user.username}`} className="sidebarListItem" activeClassName="active-link">
                        <AccountCircleOutlined className="sidebarIcon" />
                        <span className="sidebarListItemText">Profile</span>
                    </NavLink>
                    <NavLink exact to='/saved' className="sidebarListItem" activeClassName="active-link">
                        <BookmarkBorderOutlined className="sidebarIcon" />
                        <span className="sidebarListItemText">Saved</span>
                    </NavLink>
                    <NavLink exact to='/editProfile' className="sidebarListItem" activeClassName="active-link">
                        <SettingsOutlined className="sidebarIcon" />
                        <span className="sidebarListItemText">Settings</span>
                    </NavLink>
                    <a href='/roger' className="sidebarListItem" activeClassName="active-link">
                        <MessageOutlined className="sidebarIcon" />
                        <span className="sidebarListItemText">Messages</span>
                    </a>
                    <NavLink exact to='/archive' className="sidebarListItem" activeClassName="active-link">
                        <ArchiveOutlined className="sidebarIcon" />
                        <span className="sidebarListItemText">Archive</span>
                    </NavLink>
                    <NavLink exact to='/trash' className="sidebarListItem" activeClassName="active-link">
                        <DeleteOutlined className="sidebarIcon" />
                        <span className="sidebarListItemText">Trash</span>
                    </NavLink>
                </div>
                {/* <hr className="sidebarHr"/>
                <ul className="sidebarFriendsList">
                    <li className="sidebarFriend">
                        <img src= {PF + "person/2.jpg"} alt="" className="sidebarFriendImg" />
                        <span className="sidebarFriendName">Jane Doe</span>
                    </li>
                    <li className="sidebarFriend">
                        <img src= {PF + "person/2.jpg"} alt="" className="sidebarFriendImg" />
                        <span className="sidebarFriendName">Jane Doe</span>
                    </li>
                    <li className="sidebarFriend">
                        <img src= {PF + "person/2.jpg"} alt="" className="sidebarFriendImg" />
                        <span className="sidebarFriendName">Jane Doe</span>
                    </li>
                    <li className="sidebarFriend">
                        <img src= {PF + "person/2.jpg"} alt="" className="sidebarFriendImg" />
                        <span className="sidebarFriendName">Jane Doe</span>
                    </li>
                    <li className="sidebarFriend">
                        <img src= {PF + "person/2.jpg"} alt="" className="sidebarFriendImg" />
                        <span className="sidebarFriendName">Jane Doe</span>
                    </li>
                    <li className="sidebarFriend">
                        <img src= {PF + "person/2.jpg"} alt="" className="sidebarFriendImg" />
                        <span className="sidebarFriendName">Jane Doe</span>
                    </li>
                    <li className="sidebarFriend">
                        <img src= {PF + "person/2.jpg"} alt="" className="sidebarFriendImg" />
                        <span className="sidebarFriendName">Jane Doe</span>
                    </li>
                    <li className="sidebarFriend">
                        <img src= {PF + "person/2.jpg"} alt="" className="sidebarFriendImg" />
                        <span className="sidebarFriendName">Jane Doe</span>
                    </li>
                    <li className="sidebarFriend">
                        <img src= {PF + "person/2.jpg"} alt="" className="sidebarFriendImg" />
                        <span className="sidebarFriendName">Jane Doe</span>
                    </li>
                    <li className="sidebarFriend">
                        <img src= {PF + "person/2.jpg"} alt="" className="sidebarFriendImg" />
                        <span className="sidebarFriendName">Jane Doe</span>
                    </li>
                </ul> */}

            </div> 
        </div>
    )
}

export default Sidebar
